/** The image diff type. */
export enum ImageDiffType {
  /** Show the old and new images side by side. */
  TwoUp,

  /** Swipe between the old and new image. */
  Swipe,

  /** Onion skin. */
  OnionSkin,

  /** Highlight differences. */
  Difference,
}
